import { nextHalfHourLocal, toLocalInput, validateHalfHour } from './halfHour';
import { massOptionOf, REMOVAL_MASS_TYPE } from './massCatalog';

// Forhåndsutfyller «Nytt oppdrag» fra et eksisterende oppdrag («Endre og publiser på nytt»).
// Returnerer verdier i samme form som skjemaets state.
export function buildCopyPrefill(order, now = new Date()) {
  const needsEquip = !!order.requiresLoadingEquipment;
  const equipment = Array.isArray(order.loadingEquipment) ? order.loadingEquipment : [];

  // Bortkjøring er én vei: typen bortkjoring (også uten removal-flagg, og den gamle typen «removal»).
  const removal = !!order.removal || order.massType === REMOVAL_MASS_TYPE || order.massType === 'removal';
  const keepsOption = order.massType === REMOVAL_MASS_TYPE;

  // Gammel leveringstid beholdes bare når den fortsatt er frem i tid og på hel/halv time.
  const oldScheduled = order.scheduledAt?.toDate?.();
  const oldLocal = oldScheduled ? toLocalInput(oldScheduled) : '';
  const scheduledAt = oldLocal && validateHalfHour(oldLocal, now) === null
    ? oldLocal
    : nextHalfHourLocal(now);

  return {
    pickup: order.pickupAddress,
    delivery: order.deliveryAddress,
    massType: removal ? REMOVAL_MASS_TYPE : (order.massType ?? 'gravel'),
    massOption: removal && !keepsOption ? '' : (massOptionOf(order) ?? ''),
    massDesc: order.massDescription ?? '',
    tons: order.estimatedTons != null ? String(order.estimatedTons) : '',
    unit: order.unit ?? 'tons',
    removal,
    needsEquip,
    equipmentOverride: needsEquip && equipment.length > 0 ? equipment : null,
    truckOverride: order.truckCategory && !(order.containerSize > 0)
      ? { category: order.truckCategory, axles: order.truckAxlesMin ?? null, ...(order.truckTrailer === true ? { trailer: true } : {}) }
      : null,
    containerSize: order.containerSize > 0 ? order.containerSize : null,
    craneLift: order.craneLift?.tons > 0 && order.craneLift?.meters > 0
      ? { tons: String(order.craneLift.tons).replace('.', ','), meters: String(order.craneLift.meters).replace('.', ',') }
      : null,
    projectId: order.projectId ?? '',
    massAccount: order.massAccount
      ? {
          customerName: order.massAccount.customerName ?? '',
          customerNumber: order.massAccount.customerNumber ?? '',
          noAccount: !!order.massAccount.noAccount,
          reference: order.massAccount.reference ?? '',
          supplierId: order.massAccount.supplierId ?? null,
        }
      : null,
    hourly: order.hourly?.hours >= 1 && order.hourly?.rate > 0 ? { hours: order.hourly.hours, rate: order.hourly.rate } : null,
    priceMode: 'bid',
    scheduledAt,
    // Ny frist: neste hele/halve time om 24 timer.
    bidDeadline: nextHalfHourLocal(new Date(now.getTime() + 24 * 60 * 60 * 1000)),
  };
}
